import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";
import { formats } from "../../config/constants";

const GSBNMappingModel = {
    searchGSBNMapping: (body) => {
        return modelBaseV2.post('/api/gsbn/mapping/list', { body });
    },
    downloadGSBNMappingExcel: (body) => {
        body.pageSize = 0;
        const paramsMapping = {
            orderBy: "2",
            pageIndex: "3",
            pageSize: "4",
            sortBy: "24",
            siteCode: "71",
            soldToCode: "72",
            prodHir: "73",
            flagMap: "74",
        }
        const params = Object.entries(paramsMapping).map(([key, value]) => {
            let attr = body[key];
            return {
                code: value,
                value: attr
                    ? Array.isArray(attr)
                        ? attr.join('^')
                        : attr.toString()
                    : ""
            }
        })

        const exportConfig = {
            excelSheetNames: [
                "GSBN Mapping List",
                "GSBN Mapping Count"
            ],
            storedProcedureCode: "41",
            params
        }
        return modelBaseV2.postDownload('/api/executesp/export/commonexcel', { body: exportConfig }, `GSBN_SILODTO_MAP_${moment().format('YYYYMMDDhhmm')}.xlsx`);
    },
    downloadExcelTemplate: (fileName = "GSBN_Map_Template.xlsx") => {
        const exportConfig = {
            storedProcedureCode: "38",
            params: [
                {
                    "code": "66",
                    "value": "GSBN"
                }
            ],
            excelSheetNames: ["GSBN Mapping"]
        };
        return modelBaseV2.postDownload("/api/executesp/export/commontemplateremark", { body: exportConfig }, fileName);
    },
    uploadExcel: (file) => {
        let body = new FormData();
        body.append('excelTemplate', file);

        return modelBaseV2.post('/api/gsbn/mapping', { body });
    },
    downloadUploadResult: (fileId, fileName = 'GSBNMappingUploadResult') => {
        modelBaseV2.getDownload('/api/file/temp/:fileId', { params: { fileId } }, `${fileName}_${moment().format(formats.apiDateFormat)}`)
    }
}

export default GSBNMappingModel;  